var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptometryVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "57px",
    viewBox: "0 0 73 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Optometry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Optometry Icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9728,41.5829 C24.9728,48.4099 19.4378,53.9439 12.6118,53.9439 C5.7848,53.9439 0.2498,48.4099 0.2498,41.5829 C0.2498,34.7559 5.7848,29.2219 12.6118,29.2219 C19.4378,29.2219 24.9728,34.7559 24.9728,41.5829 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7824,41.5829 C69.7824,48.4099 64.2484,53.9439 57.4214,53.9439 C50.5944,53.9439 45.0594,48.4099 45.0594,41.5829 C45.0594,34.7559 50.5944,29.2219 57.4214,29.2219 C64.2484,29.2219 69.7824,34.7559 69.7824,41.5829 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9728,41.5829 C24.9728,41.5829 34.6298,31.1529 45.0598,41.5829",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0973,33.6058 C3.0973,33.6058 11.8383,6.0438 12.6113,3.7268 C13.3843,1.4088 18.7923,-5.5442 18.7923,10.6798",
    id: "Stroke-7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7917,33.6058 C66.7917,33.6058 58.0507,6.0438 57.2777,3.7268 C56.5047,1.4088 51.0967,-5.5442 51.0967,10.6798",
    id: "Stroke-9",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptometryVertical);
export default __webpack_public_path__ + "static/media/optometry-vertical.6a7900a5.svg";
export { ForwardRef as ReactComponent };